class BackInStock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)

    this.els.close.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose)
    })
  }

  handleClose () {
    this.setAttribute('aria-hidden', true)
  }

  async handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-back-in-stock-external-el="trigger"]',
    )

    if (!trigger || !window._swat) return

    this.els.title.element.innerHTML = trigger.dataset.bisProductTitle

    this.setAttribute('aria-hidden', false)

    this.els.submit.element.setAttribute(
      'data-bis-variant-id',
      trigger.dataset.bisVariantId,
    )
    this.els.submit.element.setAttribute(
      'data-bis-product-id',
      trigger.dataset.bisProductId,
    )
    this.els.submit.element.setAttribute(
      'data-bis-product-url',
      trigger.dataset.bisProductUrl,
    )
    this.els.submit.element.setAttribute(
      'data-bis-product-image',
      trigger.dataset.bisProductImage,
    )
    this.els.submit.element.setAttribute(
      'data-bis-product-price',
      trigger.dataset.bisProductPrice,
    )
  }

  handleSubmit (e) {
    if (this.els.form.element.reportValidity()) {
      e.preventDefault()

      this.addToWatchlist()
    }
  }

  addToWatchlist () {
    const mediumValue = this.els.email.element.value
    const medium = 'email'

    const product = {
      epi: this.els.submit.element.dataset.bisVariantId,
      empi: this.els.submit.element.dataset.bisProductId,
      du: this.els.submit.element.dataset.bisProductUrl,
      iu: this.els.submit.element.dataset.bisProductImage,
      pr: this.els.submit.element.dataset.bisProductPrice,
      et: 8,
    }

    let addToMailingList = 0

    if (this.els.newsletter.element.checked === true) {
      addToMailingList = 1
    }

    window._swat.sendWatchlist(
      mediumValue,
      medium,
      product,
      this.wishlistSuccess(),
      this.wishlistError,
      addToMailingList,
    )
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`)
  }

  wishlistSuccess () {
    this.els.content.element.setAttribute('aria-hidden', true)
    this.els.success.element.setAttribute('aria-hidden', false)
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock)
}
